/* eslint react/prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  setDisplayName,
  withProps,
} from 'recompose';
import Helmet from 'react-helmet';

export const Meta = ({ meta }) => <Helmet {...meta} />;

const enhance = compose(
  setDisplayName('Meta'),
  withProps(() => ({ meta: global.__PRELOADED_STATE__.meta })),
  setPropTypes({
    meta: PropTypes.object.isRequired,
  }),
);

export default enhance(Meta);
